import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyleFunc<boolean> = (loading) => ({
  opacity: loading ? 0.5 : 1,
});

export const clone: SxStyleFunc<boolean> = (isDefault) => ({
  color: (p) => p.palette.grey[500],
  cursor: isDefault ? 'no-drop' : 'pointer',
  opacity: isDefault ? 0.5 : 1,
  ':hover': {
    color: (p) => p.palette.primary[500],
  },
});

export const edit: SxStyleFunc<boolean> = (isDefault) => ({
  color: (p) => p.palette.grey[500],
  opacity: isDefault ? 0.5 : 1,
  cursor: isDefault ? 'no-drop' : 'pointer',
  ':hover': {
    color: (p) => p.palette.primary[500],
  },
});

export const action: SxStyleFunc<boolean> = (hover) => ({
  visibility: hover ? 'visible' : 'hidden',
});

export const trash: SxStyleFunc<boolean> = (isDefault) => ({
  color: (p) => p.palette.error[500],
  opacity: isDefault ? 0.5 : 1,
  cursor: isDefault ? 'no-drop' : 'pointer',
});

export const label: SxStyle = {
  margin: 0,
  gap: (p) => p.spacing(1),
  fontSize: (p) => p.typography.caption.fontSize,
  '.MuiTypography-root': {
    fontWeight: 500,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    display: 'inline-block',
  },
};
